import { CheckCircle2, Circle } from "lucide-react";
import { formatDate } from "@/lib/api";

// Shown after «Riattiva sito»: status only, nothing here publishes; each step is done with the existing buttons.
export default function ReactivationGuide({ site }) {
  if (!site.active || !site.reactivated_at) return null;
  const online = !!site.live && !site.suspended;
  const steps = [
    { key: "preview", done: site.preview?.status === "ready", title: "Anteprima pronta",
      hint: "Premi «Compila ora» in alto e controlla l'anteprima." },
    { key: "live", done: !!site.live, title: "Versione pubblicata",
      hint: "In «Pubblicazioni» scegli una compilazione pronta e pubblicala: solo tu decidi quando." },
    { key: "resume", done: online, title: "Sospensione tolta",
      hint: !site.live ? "Disponibile dopo la pubblicazione: prima i visitatori non vedrebbero nulla." : "Premi «Riattiva» in alto per mostrare di nuovo il sito ai visitatori." },
  ];
  if (steps.every((s) => s.done)) return null;
  const next = steps.find((s) => !s.done);
  return (
    <section className="rounded-xl border border-sky-200 bg-sky-50/60 px-5 py-4" data-testid="reactivation-guide">
      <h2 className="text-sm font-semibold text-slate-900">Per rimettere online il sito</h2>
      <p className="mt-0.5 text-xs text-slate-600">Riattivato nello Studio il {formatDate(site.reactivated_at)}. Nulla viene pubblicato in automatico: ogni passo lo fai tu.</p>
      <ol className="mt-3 space-y-2">
        {steps.map((s, i) => (
          <li key={s.key} className="flex gap-2.5 text-sm" data-testid={`reactivation-step-${s.key}`} data-done={s.done}>
            {s.done ? <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-emerald-600" /> : <Circle size={18} className={`mt-0.5 shrink-0 ${next === s ? "text-sky-600" : "text-slate-300"}`} />}
            <div className="min-w-0">
              <p className={`font-medium ${s.done ? "text-slate-500" : "text-slate-900"}`}>{i + 1}. {s.title} <span className="text-xs font-normal" data-testid={`reactivation-step-${s.key}-state`}>· {s.done ? "fatto" : next === s ? "da fare ora" : "in attesa"}</span></p>
              {!s.done && <p className="text-xs text-slate-600">{s.hint}</p>}
            </div>
          </li>))}
      </ol>
    </section>);
}
